import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { getCandidateStatusLabel, getEvaluationRoundLabel } from "@/utils/formatters";
import { getCandidateStatusColor } from "@/utils/statusColors";

interface StageStudent {
  id: string;
  round_name: string;
  status: string | null;
  score: number | null;
  evaluated_at: string;
  candidates: {
    id: string;
    full_name: string;
    interviewer?: string[] | null;
    colleges?: { name: string } | null;
    job_positions?: { role_name: string } | null;
  } | null;
}

interface StageStudentTableProps {
  data: StageStudent[];
  id?: string;
}

export function StageStudentTable({ data, id }: StageStudentTableProps) {
  const getNextAction = (status: string | null) => {
    switch (status) {
      case 'passed':
        return 'Schedule next round';
      case 'selected':
        return 'Prepare offer';
      case 'accepted':
        return 'Confirm joining';
      case 'joined':
        return 'Completed';
      default:
        return 'Review candidate';
    }
  };

  return (
    <Card id={id}>
      <CardHeader>
        <CardTitle>Students in Final Stages</CardTitle>
        <CardDescription>
          Latest final-stage outcome per candidate with next action
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>College</TableHead>
              <TableHead>Role</TableHead>
              <TableHead>Round</TableHead>
              <TableHead>Interviewer</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Next Action</TableHead>
              <TableHead className="text-right">Score</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} className="text-center text-muted-foreground">
                  No data available
                </TableCell>
              </TableRow>
            ) : (
              data.map((row) => (
                <TableRow key={row.id}>
                  <TableCell className="font-medium">
                    {row.candidates?.full_name || "Unknown"}
                  </TableCell>
                  <TableCell>{row.candidates?.colleges?.name || "N/A"}</TableCell>
                  <TableCell>{row.candidates?.job_positions?.role_name || "N/A"}</TableCell>
                  <TableCell>
                    <Badge variant="outline">
                      {getEvaluationRoundLabel(row.round_name as any)}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    {row.candidates?.interviewer && row.candidates.interviewer.length > 0
                      ? row.candidates.interviewer.join(', ')
                      : "Unassigned"}
                  </TableCell>
                  <TableCell>
                    <Badge className={getCandidateStatusColor(row.status || "")}> 
                      {getCandidateStatusLabel(row.status as any)}
                    </Badge>
                  </TableCell>
                  <TableCell>{getNextAction(row.status)}</TableCell>
                  <TableCell className="text-right">
                     {row.score !== null ? row.score : "-"}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
